import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import React, { Component } from 'react';
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

const urlListarPeriodosActivos = ApiUrl + "listarperiodosactivos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListCarreras = ApiUrl + 'carreras' + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCargaHorariaPeriodoCarrera = ApiUrl + 'carga-horaria-general' + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlAgregarCargaHorariaPeriodoCarrera = ApiUrl + 'carga-horaria-general' + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModificarCargaHorariaPeriodoCarrera = ApiUrl + 'carga-horaria-general';
const api_key = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"

export default class GestionHorasPracCarrera extends Component {
    constructor(props) {
        super(props)

        this.state = {
            periodo_academico_id: "",
            carrera_id: "",
            horas_practicas_laborales: "",
            horas_servicio_comunitario: "",
            periodos: [],
            carreras: [],
            modalIngresarAsignacion: false,
            modalModificarAsignacion: false,  // Nuevo modal para modificar
            currentItems: [],
            message: "",
            itemToEdit: null,  // Item que se va a modificar
        };
    }

    componentDidMount() {
        axios.get(urlListarPeriodosActivos)
            .then(response => {
                this.setState({ periodos: response.data.data });
            })
            .catch(error => {
                console.error("Error al obtener los periodos académicos", error);
            });
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });

        if (this.state.periodo_academico_id) {
            this.cargarCargasHorarias();
        } else {
            this.setState({
                currentItems: [],
                message: "Seleccione un periodo para observar las cargas horarias registradas"
            });
        }
    }

    handleChangeModal = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    cargarCargasHorarias = () => {
        if (!this.state.periodo_academico_id) {
            swal("Error", "Debe seleccionar un periodo académico", "error");
            return;
        }

        axios.get(urlCargaHorariaPeriodoCarrera, {
            params: {
                periodo_academico_id: this.state.periodo_academico_id
            }
        })
            .then(response => {
                const cargasHorarias = response.data;
                this.setState({
                    currentItems: cargasHorarias,
                    message: cargasHorarias.length === 0
                        ? "No hay horas registradas para este periodo. Utilice el botón 'Registrar Asignación' para agregar cargas horarias."
                        : ""
                });
            })
            .catch(error => {
                console.log(error);
                swal("Error", "No se pudieron cargar las cargas horarias", "error");
            });
    }

    mostrarModalAgregarAsignacion = async () => {
        if (!this.state.periodo_academico_id) {
            swal('Advertencia', 'Por favor, seleccione un periodo académico', 'warning');
            return;
        }

        try {
            const response = await axios.get(urlListCarreras, {
                params: { periodo_academico_id: this.state.periodo_academico_id }
            });

            const carrerasRegistradas = this.state.currentItems.map(item => item.carrera_id);
            const carrerasDisponibles = response.data.filter(
                carrera => !carrerasRegistradas.includes(carrera.id_carrera)
            );

            if (carrerasDisponibles.length === 0) {
                swal('Información', 'Todas las carreras ya tienen carga horaria asignada para este periodo académico. Seleccione otro periodo para agregar más carreras.', 'info');
                return;
            }

            this.setState({
                carreras: carrerasDisponibles,
                modalIngresarAsignacion: true,
                carrera_id: "",
                horas_practicas_laborales: "",
                horas_servicio_comunitario: ""
            });
        } catch (error) {
            console.error("Error al cargar las carreras:", error);
            swal('Error', 'No se pudieron cargar las carreras', 'error');
        }
    }

    ocultarModalAgregarAsignacion = () => {
        this.setState({
            modalIngresarAsignacion: false,
            carrera_id: "",
            horas_practicas_laborales: "",
            horas_servicio_comunitario: ""
        });
    }

    handleSubmitIngresar = async (event) => {
        event.preventDefault();

        const { periodo_academico_id, carrera_id, horas_practicas_laborales, horas_servicio_comunitario } = this.state;

        if (!periodo_academico_id || !carrera_id) {
            swal('Advertencia', 'Por favor, seleccione un periodo académico y una carrera', 'warning');
            return;
        }

        if (!horas_practicas_laborales && !horas_servicio_comunitario) {
            swal('Advertencia', 'Debe ingresar al menos una hora en cualquiera de los dos campos', 'warning');
            return;
        }

        const carreraYaRegistrada = this.state.currentItems.some(
            item => item.carrera_id === parseInt(carrera_id)
        );

        if (carreraYaRegistrada) {
            swal('Advertencia', 'Esta carrera ya tiene una carga horaria registrada para este periodo académico. Solo puede registrar una vez por periodo.', 'warning');
            return;
        }

        try {
            const response = await axios.post(urlAgregarCargaHorariaPeriodoCarrera, {
                periodo_academico_id,
                carrera_id,
                horas_practicas_laborales: horas_practicas_laborales || 0,
                horas_servicio_comunitario: horas_servicio_comunitario || 0
            });

            if (response.data.success) {
                swal("Éxito", "Carga horaria registrada correctamente", "success");

                this.setState({
                    carrera_id: "",
                    horas_practicas_laborales: "",
                    horas_servicio_comunitario: "",
                    modalIngresarAsignacion: false,
                });

                this.cargarCargasHorarias();
            }
        } catch (error) {
            console.error("Error al registrar:", error);

            if (error.response?.status === 422) {
                swal("Advertencia", error.response.data.message || "Esta carrera ya tiene una carga horaria registrada para este periodo.", "warning");
            } else if (error.response?.status === 400) {
                swal("Error", error.response.data.message || "El total de horas para esta carrera y periodo ha sido superado.", "error");
            } else {
                const errorMessage = error.response?.data?.message || "Error al registrar la carga horaria. Por favor verifique los datos ingresados.";
                swal("Error", errorMessage, "error");
            }
        }
    }

    // NUEVA FUNCIÓN: Abrir modal de modificación
    modificarCargaHoraria = async (item) => {
        try {
            // Cargar todas las carreras
            const response = await axios.get(urlListCarreras, {
                params: { periodo_academico_id: this.state.periodo_academico_id }
            });

            this.setState({
                modalModificarAsignacion: true,
                itemToEdit: item,
                periodo_academico_id: item.periodo_academico_id,
                carrera_id: item.carrera_id,
                horas_practicas_laborales: item.horas_practicas_laborales || "",
                horas_servicio_comunitario: item.horas_servicio_comunitario || "",
                carreras: response.data
            });
        } catch (error) {
            console.error("Error al cargar las carreras:", error);
            swal('Error', 'No se pudieron cargar las carreras', 'error');
        }
    }

    // NUEVA FUNCIÓN: Cerrar modal de modificación
    ocultarModalModificarAsignacion = () => {
        this.setState({
            modalModificarAsignacion: false,
            itemToEdit: null,
            carrera_id: "",
            horas_practicas_laborales: "",
            horas_servicio_comunitario: ""
        });
    }

    // NUEVA FUNCIÓN: Enviar modificación
    handleSubmitModificar = async (event) => {
        event.preventDefault();

        const { itemToEdit, periodo_academico_id, carrera_id, horas_practicas_laborales, horas_servicio_comunitario } = this.state;

        if (!periodo_academico_id || !carrera_id) {
            swal('Advertencia', 'Por favor, seleccione un periodo académico y una carrera', 'warning');
            return;
        }

        if (!horas_practicas_laborales && !horas_servicio_comunitario) {
            swal('Advertencia', 'Debe ingresar al menos una hora en cualquiera de los dos campos', 'warning');
            return;
        }

        // Validación: si cambió la carrera, verificar que no esté duplicada
        if (parseInt(carrera_id) !== itemToEdit.carrera_id) {
            const carreraYaRegistrada = this.state.currentItems.some(
                item => item.carrera_id === parseInt(carrera_id) &&
                    item.id !== itemToEdit.id
            );

            if (carreraYaRegistrada) {
                swal('Advertencia', 'Esta carrera ya tiene una carga horaria registrada para este periodo académico.', 'warning');
                return;
            }
        }

        try {
            const response = await axios.put(
                `${urlModificarCargaHorariaPeriodoCarrera}/${itemToEdit.id} ${api_key}`,
                {
                    periodo_academico_id,
                    carrera_id,
                    horas_practicas_laborales: horas_practicas_laborales || 0,
                    horas_servicio_comunitario: horas_servicio_comunitario || 0
                }
            );

            if (response.data.success) {
                swal("Éxito", "Carga horaria modificada correctamente", "success");

                this.setState({
                    modalModificarAsignacion: false,
                    itemToEdit: null,
                    carrera_id: "",
                    horas_practicas_laborales: "",
                    horas_servicio_comunitario: ""
                });

                this.cargarCargasHorarias();
            }
        } catch (error) {
            console.error("Error al modificar:", error);

            if (error.response?.status === 422) {
                swal("Advertencia", error.response.data.message || "Esta carrera ya tiene una carga horaria registrada para este periodo.", "warning");
            } else if (error.response?.status === 400) {
                swal("Error", error.response.data.message || "El total de horas para esta carrera y periodo ha sido superado.", "error");
            } else if (error.response?.status === 404) {
                swal("Error", "Carga horaria no encontrada", "error");
            } else {
                const errorMessage = error.response?.data?.message || "Error al modificar la carga horaria. Por favor verifique los datos ingresados.";
                swal("Error", errorMessage, "error");
            }
        }
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    {/* ENCABEZADO */}
                    <div className="back-istmas">
                        <i className="fa fa-clock bounce-custom fs-5"></i>
                        <b className="ms-2">Gestión de Horas Prácticas Carrera</b>
                    </div>

                    {/* FILTROS Y BOTÓN DE REGISTRO */}
                    <div className="row mt-3">
                        <div className="col-12 col-sm-12 col-lg-6 text-azul">
                            <label>
                                <b><i className="fa fa-calendar me-2"></i>Período</b>
                            </label>
                            <select
                                className="form-select form-select-sm"
                                name="periodo_academico_id"
                                value={this.state.periodo_academico_id || ""}
                                onChange={this.handleChange}
                            >
                                <option value="" disabled>Seleccione el periodo</option>
                                {this.state.periodos.map((periodo) => (
                                    <option key={periodo.id_periodo_academico} value={periodo.id_periodo_academico}>
                                        {periodo.descripcion_periodo_academico}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-12 col-sm-12 col-lg-6 d-flex align-items-end justify-content-center mt-3 mt-lg-0">
                            <button
                                id="registrarAsignacion"
                                type="button"
                                className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                onClick={this.mostrarModalAgregarAsignacion}
                                disabled={!this.state.periodo_academico_id}
                            >
                                <i className="fas fa-plus me-1"></i>Registrar Asignación
                            </button>
                        </div>
                    </div>

                    {/* TABLA DE REGISTROS */}
                    {this.state.periodo_academico_id && (
                        <div className="card-body mt-3">
                            <h6 className="fw-bold text-center mb-3 text-azul">
                                Carga Horaria - {this.state.periodos.find(p => p.id_periodo_academico == this.state.periodo_academico_id)?.descripcion_periodo_academico || ""}
                            </h6>

                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr className="text-azul text-center">
                                            <th>Carrera</th>
                                            <th>Horas Prácticas Laborales</th>
                                            <th>Horas Servicio Comunitario</th>
                                            <th>Modificar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.currentItems.length > 0 ? (
                                            this.state.currentItems.map((item, index) => (
                                                <tr key={item.id || `${item.carrera_id}-${index}`} className="text-azul text-center">
                                                    <td>{item.carrera.descripcion_carrera}</td>
                                                    <td><span className="badge bg-primary px-2 py-1">{item.horas_practicas_laborales || 0} hrs</span></td>
                                                    <td><span className="badge bg-success px-2 py-1">{item.horas_servicio_comunitario || 0} hrs</span></td>
                                                    <td>
                                                        <button
                                                            className="btn btn-outline-primary btn-sm"
                                                            onClick={() => this.modificarCargaHoraria(item)}
                                                            title="Modificar"
                                                            style={{ borderRadius: "8px" }}
                                                        >
                                                            <i className="fas fa-pen"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center text-muted py-3">
                                                    {this.state.message || "Seleccione un período para visualizar las cargas horarias registradas."}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                </div>
                {/* MODAL REGISTRAR */}
                <Modal isOpen={this.state.modalIngresarAsignacion} size="lg" centered>
                    <ModalHeader className="back-istmas text-white">
                        <i className="fa fa-plus-circle me-2"></i>Registrar Carga Horaria
                    </ModalHeader>
                    <ModalBody>
                        <p className="text-center text-muted mb-3">
                            Por favor, ingrese los datos requeridos para registrar la carga horaria.
                        </p>
                        <FormGroup>
                            <label className="form-label text-azul">Carrera <span className="text-danger">*</span></label>
                            <select
                                className="form-select"
                                name="carrera_id"
                                value={this.state.carrera_id || ""}
                                onChange={this.handleChangeModal}
                                required
                            >
                                <option value="" disabled>Seleccione la carrera</option>
                                {this.state.carreras.map(c => (
                                    <option key={c.id_carrera} value={c.id_carrera}>
                                        {c.descripcion_carrera}
                                    </option>
                                ))}
                            </select>
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <label className="form-label text-azul">Horas Prácticas Laborales</label>
                            <input type="number" className="form-control" name="horas_practicas_laborales"
                                value={this.state.horas_practicas_laborales} onChange={this.handleChangeModal} min="0" />
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <label className="form-label text-azul">Horas Servicio Comunitario</label>
                            <input type="number" className="form-control" name="horas_servicio_comunitario"
                                value={this.state.horas_servicio_comunitario} onChange={this.handleChangeModal} min="0" />
                        </FormGroup>

                        <div className="alert alert-warning mt-3 small">
                            <i className="fas fa-exclamation-triangle me-1"></i>
                            Debe ingresar al menos una hora en cualquiera de los dos campos.
                        </div>
                        <div className="alert alert-info mt-2 small">
                            <i className="fas fa-info-circle me-1"></i>
                            Solo puede registrar cada carrera una vez por período académico.
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-outline-success"
                            onClick={this.handleSubmitIngresar}
                        >
                            <i className="fas fa-save me-1"></i>Guardar
                        </button>
                        <button className="btn btn-outline-danger" onClick={this.ocultarModalAgregarAsignacion}>
                            <i className="fas fa-times me-1"></i>Cancelar
                        </button>
                    </ModalFooter>
                </Modal>

                {/* MODAL MODIFICAR */}
                <Modal isOpen={this.state.modalModificarAsignacion} size="lg" centered>
                    <ModalHeader className="back-istmas text-white">
                        <i className="fa fa-edit me-2"></i>Modificar Carga Horaria
                    </ModalHeader>
                    <ModalBody>
                        <p className="text-center text-muted mb-3">
                            Modifique los datos de la carga horaria seleccionada.
                        </p>

                        <FormGroup>
                            <label className="form-label text-azul">Carrera <span className="text-danger">*</span></label>
                            <select
                                className="form-select"
                                name="carrera_id"
                                value={this.state.carrera_id || ""}
                                onChange={this.handleChangeModal}
                                required
                                disabled
                            >
                                <option value="" disabled>Seleccione la carrera</option>
                                {this.state.carreras.map(c => (
                                    <option key={c.id_carrera} value={c.id_carrera}>
                                        {c.descripcion_carrera}
                                    </option>
                                ))}
                            </select>
                            <small className="text-muted">La carrera no se puede modificar.</small>
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <label className="form-label text-azul">Horas Prácticas Laborales</label>
                            <input type="number" className="form-control" name="horas_practicas_laborales"
                                value={this.state.horas_practicas_laborales} onChange={this.handleChangeModal} min="0" />
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <label className="form-label text-azul">Horas Servicio Comunitario</label>
                            <input type="number" className="form-control" name="horas_servicio_comunitario"
                                value={this.state.horas_servicio_comunitario} onChange={this.handleChangeModal} min="0" />
                        </FormGroup>

                        <div className="alert alert-info mt-3 small">
                            <i className="fas fa-info-circle me-1"></i>
                            Debe ingresar al menos una hora en cualquiera de los dos campos.
                        </div>
                    </ModalBody>
                    <ModalFooter>
                         <button
                            type="button"
                            className="btn btn-outline-success"
                            onClick={this.handleSubmitModificar}
                        >
                            <i className="fas fa-save me-1"></i>Actualizar
                        </button>
                        <button className="btn btn-outline-danger" onClick={this.ocultarModalModificarAsignacion}>
                            <i className="fas fa-times me-1"></i>Cancelar
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
